import React from "react";

import "./DownloadApp.css";

function DownloadApp() {
  return (
    <>
      <div className="download-app__section">
        <div className="download-app__container">
          <div className="download-app__row">
            <div className="download-app__col">
              <div className="download-app__text-wrapper">
                <p className="download-app__heading">
                  ダウンロードはこちらから
                </p>
                <p className="download-app__description">
                  Workom は、iOS および Android で動作するモバイル SNS
                  アプリです。今すぐアプリをダウンロードして、社会人と交流しよう！
                </p>
              </div>
              <div className="download-app__download-row">
                <div className="download-app__playstore-img-wrapper">
                  <a href="https://play.google.com/store/apps/details?id=jp.workom">
                    <img
                      src="images/googleplay.png"
                      alt="Google Play で手に入れよう"
                      className="download-app__playstore-img"
                    />
                  </a>
                </div>
                <div className="download-app__appstore-img-wrapper">
                  <a href="https://apps.apple.com/jp/app/workom-%E6%96%B0%E3%81%97%E3%81%84%E5%8C%BF%E5%90%8Dsns%E3%81%A7%E7%A4%BE%E4%BC%9A%E4%BA%BA%E3%81%A8%E4%BA%A4%E6%B5%81%E3%81%97%E3%82%88%E3%81%86/id1601043751?itsct=apps_box_link&itscg=30200">
                    <img
                      src="images/appstore.svg"
                      alt="App Store からダウンロード"
                      className="download-app__appstore-img"
                    />
                  </a>
                </div>
              </div>
            </div>
            <div className="download-app__col">
              <div className="download-app__qr-wrapper">
                <img
                  src="images/workom-qr.svg"
                  alt=""
                  className="download-app__qr"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default DownloadApp;
